import { Inject, Injectable } from '@angular/core';
import { ClientManagerInstanceToken, ClientManagerInterface } from '../../interfaces/client-manager.interface';

enum MockDataPaths {
    AP1 = 'assets/mockdata-cn',
    P58 = 'assets/mockdata-p58',
    P40 = 'assets/mockdata-p40',
    SA = 'assets/mockdata-sa',
}

@Injectable()
export class EnvironmentPathUtilitiesService {
    public constructor(@Inject(ClientManagerInstanceToken) private readonly clientManager: ClientManagerInterface) {}

    public getMockDataPath(): MockDataPaths {
        let path = MockDataPaths.P58;

        if (this.clientManager.isNgmChina()) {
            path = MockDataPaths.AP1;
        }
        return path;
    }
}
